/** Apparence Clerk alignée sur Faanuu — couleurs explicites (lisibles clair/sombre). */

const PALETTES = {
  dark: {
    colorBackground: "#2c1b10",
    colorForeground: "#f5f0e6",
    colorPrimary: "#d4af37",
    colorPrimaryForeground: "#1a100c",
    colorMuted: "#3d2818",
    colorMutedForeground: "#b8a89a",
    colorInput: "#1a100c",
    colorInputForeground: "#f5f0e6",
    colorBorder: "#6b5344",
    colorRing: "#d4af37",
    colorNeutral: "#f5f0e6",
    colorDanger: "#f87171",
    colorModalBackdrop: "rgba(0, 0, 0, 0.72)",
    primaryHover: "#e6c65c",
    surfaceHover: "#4a3219",
  },
  light: {
    colorBackground: "#fffaf2",
    colorForeground: "#1a100c",
    colorPrimary: "#8a6500",
    colorPrimaryForeground: "#fffaf2",
    colorMuted: "#f0e8dc",
    colorMutedForeground: "#5c4a3a",
    colorInput: "#ffffff",
    colorInputForeground: "#1a100c",
    colorBorder: "#b8a080",
    colorRing: "#8a6500",
    colorNeutral: "#1a100c",
    colorDanger: "#dc2626",
    colorModalBackdrop: "rgba(26, 16, 12, 0.55)",
    primaryHover: "#a67c00",
    surfaceHover: "#e8dcc8",
  },
};

export function getClerkAppearance(resolvedTheme = "dark") {
  const isLight = resolvedTheme === "light";
  const c = isLight ? PALETTES.light : PALETTES.dark;

  return {
    variables: {
      colorBackground: c.colorBackground,
      colorForeground: c.colorForeground,
      colorPrimary: c.colorPrimary,
      colorPrimaryForeground: c.colorPrimaryForeground,
      colorMuted: c.colorMuted,
      colorMutedForeground: c.colorMutedForeground,
      colorInput: c.colorInput,
      colorInputForeground: c.colorInputForeground,
      colorBorder: c.colorBorder,
      colorRing: c.colorRing,
      colorNeutral: c.colorNeutral,
      colorDanger: c.colorDanger,
      colorModalBackdrop: c.colorModalBackdrop,
      borderRadius: "0.5rem",
      fontFamily: '"DM Sans", system-ui, sans-serif',
    },
    elements: {
      rootBox: { width: "100%" },
      card: {
        backgroundColor: c.colorBackground,
        border: `1px solid ${c.colorBorder}`,
        boxShadow: isLight
          ? "0 12px 40px rgba(26, 16, 12, 0.14)"
          : "0 12px 40px rgba(0, 0, 0, 0.5)",
      },
      modalContent: {
        backgroundColor: c.colorBackground,
        border: `1px solid ${c.colorBorder}`,
      },
      headerTitle: { color: c.colorForeground, fontWeight: 700 },
      headerSubtitle: { color: c.colorMutedForeground },
      socialButtonsBlockButton: {
        border: `1px solid ${c.colorBorder}`,
        color: c.colorForeground,
        backgroundColor: c.colorInput,
        boxShadow: "none",
        "&:hover": {
          backgroundColor: c.surfaceHover,
          borderColor: c.colorPrimary,
        },
      },
      socialButtonsBlockButtonText: {
        color: c.colorForeground,
        fontWeight: 600,
      },
      formButtonPrimary: {
        backgroundColor: c.colorPrimary,
        color: c.colorPrimaryForeground,
        fontWeight: 600,
        boxShadow: isLight
          ? "0 4px 14px rgba(138, 101, 0, 0.25)"
          : "0 4px 14px rgba(212, 175, 55, 0.25)",
        "&:hover": {
          backgroundColor: c.primaryHover,
        },
      },
      formFieldInput: {
        backgroundColor: c.colorInput,
        borderColor: c.colorBorder,
        color: c.colorInputForeground,
        "&:focus": {
          borderColor: c.colorPrimary,
          boxShadow: `0 0 0 2px ${isLight ? "rgba(138, 101, 0, 0.25)" : "rgba(212, 175, 55, 0.3)"}`,
        },
      },
      formFieldLabel: { color: c.colorForeground },
      footerActionLink: { color: c.colorPrimary, fontWeight: 600 },
      identityPreviewText: { color: c.colorForeground },
      dividerLine: { backgroundColor: c.colorBorder },
      dividerText: { color: c.colorMutedForeground },
      alternativeMethodsBlockButton: {
        border: `1px solid ${c.colorBorder}`,
        color: c.colorForeground,
        "&:hover": { backgroundColor: c.surfaceHover },
      },
    },
  };
}
